module.exports = __webpack_public_path__ + "static/media/webChatImage.817e5af7.svg";